// ORDER MATTERS
import './env';
import './public-path';
import './polyfill/browser';
import './telemetry';

import { installBootTrace, recordBootEvent } from './boot-trace';

installBootTrace();
recordBootEvent('browser-bootstrap-loaded');
